import { render, staticRenderFns } from "./Identify.vue?vue&type=template&id=37599e3d&scoped=true"
import script from "./Identify.vue?vue&type=script&lang=js"
export * from "./Identify.vue?vue&type=script&lang=js"
import style0 from "./Identify.vue?vue&type=style&index=0&id=37599e3d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37599e3d",
  null
  
)

export default component.exports